<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="active" ref="popup" class="grid popup">
        <div ref="popupContent" class="content">
          <div class="content-inner">
            <slot />
          </div>
          <BaseButton
            class="close"
            type="submit"
            color="primary"
            size="l"
            :text="t('close-popup')"
            @click="close"
          />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import { onClickOutside, onKeyStroke } from '@vueuse/core'

const props = defineProps<{
  active: boolean
}>()

const { t } = useI18n()
const emit = defineEmits(['close'])

function close() {
  emit('close')
}

const popup = ref<HTMLElement>()
const { blockScroll, unblockScroll } = useScrollLock(popup)

watch(
  () => props.active,
  isActive => {
    if (isActive) {
      blockScroll()
    } else {
      unblockScroll()
    }
  }
)

const popupContent = ref<HTMLElement>()
onClickOutside(popupContent, close)
onKeyStroke('Escape', close)
</script>

<style lang="scss" scoped>
.popup {
  @include fill-space($position: fixed);
  inset: 0;
  z-index: z(popup);
  align-items: center;
  padding-top: $nav-height;
  overflow-y: auto;
  background-color: rgba($global-white, 0.8);
}

.content {
  @include media-column(
    (
      xs: 12,
      s-lg: 10 1,
      lg: 8 2
    )
  );
  display: flex;
  flex-direction: column;
  min-height: rem(411px);
  padding-block: rem(48px);
  padding-inline: rem(20px);
  background-color: $global-white;
  border-radius: $border-radius-mid;
  box-shadow: $popup-shadow;

  @include media-up(md) {
    min-height: rem(400px);
    padding-inline: rem(48px);
  }

  @include media-up(s-lg) {
    padding-inline: rem(90px);
  }
}

.content-inner {
  @include center-content;
  flex-grow: 1;
}

.close {
  margin-inline: auto;
  margin-top: rem(28px);
}
</style>
